import { useState } from "react";
import MainNavbar from "../../MainNavbar";
import MatchCard from "./MatchCard";
import api from "../../../../utils/api";
import "./Match.css";
import { useContext } from "react";
import AlertContext from "../../../../contexts/AlertContext";

export default function MatchPage() {
  const [userInfo, setUserInfo] = useState("");
  const [partnerInfo, setPartnerInfo] = useState("");
  const [loading, setLoading] = useState(false);
  const [matches, setMatches] = useState([]);
const { showAlert } = useContext(AlertContext);
  const handleMatchCheck = async () => {
    if (!userInfo || !partnerInfo) {
      showAlert("Please describe both profiles!", "error");
      return;
    }

    setLoading(true);
    setMatches([]);

    try {
      const data = await api.match(userInfo, partnerInfo);
      setMatches(data.matches || []);
    } catch (error) {
      console.error(error);
      alert("Error while analyzing match");
    }

    setLoading(false);
  };

  return (
    <div className="ai-page-container">
      <MainNavbar />

      <div className="ai-content">
        <h2 className="ai-title">💞 AI Match Analyzer</h2>

        <div className="ai-layout">
          {/* LEFT SIDE */}
          <div className="ai-input-section">
            <textarea
              className="ai-textarea"
              placeholder="Describe yourself (age, hobbies, personality, values...)"
              value={userInfo}
              onChange={(e) => setUserInfo(e.target.value)}
            />

            <textarea
              className="ai-textarea"
              placeholder="Describe your partner (age, hobbies, personality, expectations...)"
              value={partnerInfo}
              onChange={(e) => setPartnerInfo(e.target.value)}
            />

            <button
              className="ai-button"
              onClick={handleMatchCheck}
              disabled={loading}
            >
              {loading ? "Analyzing Compatibility..." : "Analyze Match"}
            </button>
          </div>

          {/* RIGHT SIDE */}
          <div className="ai-result-box">
            {loading ? (
              <p>🔍 Analyzing compatibility...</p>
            ) : matches.length > 0 ? (
              matches.map((match) => (
                <MatchCard key={match._id} match={match} />
              ))
            ) : (
              <p>💔 No match yet. Start by analyzing compatibility.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
